module.exports = __webpack_public_path__ + "static/img/Logo.17ea86d6.svg";